import React from 'react';
import { useSuccessionTheme } from './SuccessionThemeProvider';

const ProgressBar = ({ currentSection, totalSections, sectionTitles }) => {
  const { theme, isLightTheme, isDarkTheme, company } = useSuccessionTheme();
  
  const progress = ((currentSection + 1) / totalSections) * 100;
  const currentSectionName = sectionTitles[currentSection] || '';

  return (
    <div className="mt-4">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="h-2 rounded-full bg-succession-bg-tertiary transition-colors duration-300">
            <div
              className="h-2 rounded-full bg-succession-primary transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>
        <div className="ml-4 text-sm text-succession-text-secondary transition-colors duration-300">
          {currentSection + 1} of {totalSections}
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between text-sm">
        {currentSection > 0 && (
          <div className="text-succession-text-muted transition-colors duration-300">
            ← {sectionTitles[currentSection - 1]}
          </div>
        )}
        <div className="font-medium mx-2 truncate text-succession-primary transition-colors duration-300">
          {currentSectionName}
        </div>
        {currentSection < totalSections - 1 && (
          <div className="text-succession-text-muted transition-colors duration-300">
            {sectionTitles[currentSection + 1]} →
          </div>
        )}
      </div>
    </div>
  );
};

export default ProgressBar; 